module.exports = __webpack_public_path__ + "img/32_3.63579a15.png";